import { OfferOriginEnum } from '@luminovo/api-contracts';

/** `Consigned` is a direct-API origin on the wire, but consigned stock isn't fetched either. */
const NON_API_ORIGINS: OfferOriginEnum[] = [
    OfferOriginEnum.Manual,
    OfferOriginEnum.Import,
    OfferOriginEnum.QuoteRequest,
    OfferOriginEnum.Consigned,
];

export function isApiOfferOrigin(origin: { origin: OfferOriginEnum }): boolean {
    return !NON_API_ORIGINS.includes(origin.origin);
}

/** Looks only at selected offers, all the calculation carries, so manually selected items hide fresh API offers. */
export function getNewestApiOfferDate(
    lineItems: Array<{ offer: { origin: { origin: OfferOriginEnum }; creation_date: string } | null }>,
): string | undefined {
    let newest: string | undefined = undefined;

    for (const { offer } of lineItems) {
        if (!offer || !isApiOfferOrigin(offer.origin)) {
            continue;
        }
        if (newest === undefined || Date.parse(offer.creation_date) > Date.parse(newest)) {
            newest = offer.creation_date;
        }
    }

    return newest;
}

export const API_OFFER_STALE_AFTER_HOURS = 24;

export function isApiOfferDateStale(creationDate: string, now: Date = new Date()): boolean {
    return now.getTime() - Date.parse(creationDate) > API_OFFER_STALE_AFTER_HOURS * 60 * 60 * 1000;
}
